const replaceSpecialCaracter = (string = '') => {
let texto = String(string);
    texto = texto.replace(/&#(\d+);/gm, (match, dec) => {
    return String.fromCharCode(dec);
  });
  texto = texto.replace(/&Aacute;/g, 'Á');
  texto = texto.replace(/&aacute;/g, 'á');
  texto = texto.replace(/&Acirc;/g, 'Â');
  texto = texto.replace(/&acirc;/g, 'â');
  texto = texto.replace(/&Agrave;/g, 'À');
  texto = texto.replace(/&agrave;/g, 'à');
  texto = texto.replace(/&Atilde;/g, 'Ã');
  texto = texto.replace(/&atilde;/g, 'ã');
  texto = texto.replace(/&ccedil;/g, 'ç');
  texto = texto.replace(/&Ccedil;/g, 'Ç');

  texto = texto.replace(/&Eacute;/g, 'É');
  texto = texto.replace(/&eacute;/g, 'é');
  texto = texto.replace(/&Ecirc;/g, 'Ê');
  texto = texto.replace(/&ecirc;/g, 'ê');

  texto = texto.replace(/&Iacute;/g, 'Í');
  texto = texto.replace(/&iacute;/g, 'í');

  texto = texto.replace(/&Oacute;/g, 'Ó');
  texto = texto.replace(/&oacute;/g, 'ó');
  texto = texto.replace(/&Ocirc;/g, 'Ô');
  texto = texto.replace(/&ocirc;/g, 'ô');
  texto = texto.replace(/&Otilde;/g, 'Õ');
  texto = texto.replace(/&otilde;/g, 'õ');

  texto = texto.replace(/&Uacute;/g, 'Ú');
  texto = texto.replace(/&uacute;/g, 'ú');

  // Aspas e apóstrofos
  texto = texto.replace(/&lsquo;/g, '‘');
  texto = texto.replace(/&rsquo;/g, '’');
  texto = texto.replace(/&ldquo;/g, '“');
  texto = texto.replace(/&rdquo;/g, '”');

  // Outras entidades comuns
  texto = texto.replace(/&nbsp;/g, ' ');
  texto = texto.replace(/&amp;/g, '&');
  texto = texto.replace(/&quot;/g, '"');
  texto = texto.replace(/&lt;/g, '<');
  texto = texto.replace(/&gt;/g, '>');
  texto = texto.replace(/(?<=[a-zA-ZÀ-ú]);(?=[a-zA-ZÀ-ú])/g, '');

  return texto;
};

export default replaceSpecialCaracter;